import React from 'react'

export interface MobileCartIconProps {
  className?: string
  quantityText: string
}

const MobileCartIcon: React.VFC<MobileCartIconProps> = ({ className, quantityText }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    overflow="visible"
  >
    <defs>
      <clipPath id="punch-corner">
        <path fill="none" d="M64,32V0H0v64H22.63C22.63,46.8,41.37,32,64,32Z" />
      </clipPath>
    </defs>
    <g fill="currentColor" clipPath={quantityText ? 'url(#punch-corner)' : ''}>
      <path d="M26.84,50.35A5.63,5.63,0,1,0,32.46,56,5.64,5.64,0,0,0,26.84,50.35Zm0,8.12A2.49,2.49,0,1,1,29.32,56,2.49,2.49,0,0,1,26.84,58.47Z" />
      <path d="M46.58,50.35A5.63,5.63,0,1,0,52.21,56,5.64,5.64,0,0,0,46.58,50.35Zm0,8.12A2.49,2.49,0,1,1,49.06,56,2.5,2.5,0,0,1,46.58,58.47Z" />
      <path d="M25.45,23.86H48a1.57,1.57,0,1,0,0-3.14H25.45a1.57,1.57,0,1,0,0,3.14Z" />
      <path d="M46.74,28.88H26.67a1.57,1.57,0,1,0,0,3.14H46.74a1.57,1.57,0,0,0,0-3.14Z" />
      <path d="M63.29,13.72a3.11,3.11,0,0,0-2.43-1.16H11.91l-1-4.8A3.16,3.16,0,0,0,9.09,5.51l-6.89-3A1.57,1.57,0,1,0,1,5.4l6.89,3,7.61,36.9a3.14,3.14,0,0,0,3.07,2.51H56.17a1.57,1.57,0,0,0,0-3.14H18.52l-.92-4.49H56.46a3.15,3.15,0,0,0,3.08-2.51l4.39-21.33A3.09,3.09,0,0,0,63.29,13.72ZM56.46,37H17L12.56,15.7h48.3Z" />
    </g>
    <text
      className="cart-icon-qty-text"
      x={quantityText.length <= 2 ? '54' : '60'}
      y="68"
      fill="currentColor"
      textAnchor="middle"
      fontSize="28px"
    >
      {quantityText}
    </text>
  </svg>
)

export default MobileCartIcon
